import React, {useState ,useEffect } from "react";
import "./Cart.css";
import { RiDeleteBin6Line } from "react-icons/ri";
import { AiOutlineMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import { deleteCart, getCartDetails } from "../../Redux/Actions";
import { useDispatch , useSelector } from "react-redux";
import { connect } from "react-redux";
import { SMS_VERIFICATION_CANCEL_SUCCESS } from "../../Redux/Constants";
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import { useHistory, useLocation } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsFillExclamationCircleFill } from "react-icons/bs";


const PackageInfo = (props) => {
  const history = useHistory();

  const { Review, cartData, notavailPack } = props
  const { package: cart } = cartData && cartData;
  const Mrp = cart.package_price;
  const offerPrice = cart.offer_price;
  const discount = Mrp - offerPrice;
  const finalPrice = Mrp - discount;

  const discountPercentage = Math.floor((discount / Mrp) * 100);
  const dispatch = useDispatch();

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;
  const [open, setOpen] = useState(false);
  const [packageData, setpackageData1] = useState();

  const onCloseModal = () => setOpen(false);
  toast.configure()
  const successCb = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;
    dispatch(getCartDetails(token , citySelect && citySelect ));
    toast.success('This item is successfully removed from the cart.',{position: toast.POSITION.BOTTOM_CENTER, bodyClassName:'singleItemsss'});
  };
  const deleteItem = (packageD) => {
    setOpen(true);
    setpackageData1(packageD)

    // const userFromLocal = JSON.parse(localStorage.getItem("user"));
    // var token = userFromLocal.token;

    // dispatch(deleteCart(token, id, successCb));

    // toast.error("Package successfully removed from cart", {
    //   position: "bottom-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
  };
  const closeModal = ()=>{
    setOpen(false)
  }
  const deletePackage=(deleteP)=>{
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;
    dispatch(deleteCart(token, deleteP, successCb));
    setOpen(false)
  }

  return (
    <>
    <div className="box">
      {console.log("this is cart data", cartData)}
      <div className="flexDirect paddng_2 borderBtm">
        <div className="packageNotForCity" style={{width:"90%"}}>
          <h2 className={cart?.available == false ? 'packageNotCity':'textblueBold'}>{cart?.name}</h2>
          {cart?.available == false ?
            <p className={cart?.available == false ? 'packageNotCity':'textblueBold'} style={{marginTop:"15px"}}>Price Rs. {props?.AddonState ? cart?.package_city_prices?.offer_price ? cart?.package_city_prices?.offer_price : cart?.offer_price : cart.is_addon ? cart.addon_price : cart?.package_city_prices?.offer_price ? cart?.package_city_prices?.offer_price : cart?.offer_price }/-</p>
          :null}
        </div>
        {Review ? null : (
          <RiDeleteBin6Line 
            onClick={() => deleteItem(cartData)}
            style={{ cursor: "pointer" , color:"red" , fontSize: "2rem" }}
          />
        )}

      </div>
      <div className="">
        {cart?.available == true || cart?.available == null?
        <div style={{ marginTop: "1rem" }}>
    
          <span
            className="paddng_2"
            style={{ fontWeight: "600", color: "gray" }}
          >
            {cart?.parameter > 1 ? "Inclusions" : "Inclusion"} :{" "}
            {cart?.parameter > 1
              ? `${cart?.parameter} Tests`
              : `${cart?.parameter} Test`}
          </span>
          
          <p className="paddng_2">{cart?.description}</p>
        </div>
        :null}
        {cart?.available == true || cart?.available == null ?
        <div className="flexDirect" style={{    borderTop: "1px solid gainsboro"}}>
          <div className="price_info">
            <span
              className="textpink"
              style={{ textDecoration: "line-through" }}
            >
              Rs.{cart?.package_city_prices?.package_price ? cart?.package_city_prices?.package_price : cart?.package_price}/-
            </span>
            <span className={cart?.available == false ? 'packageNotCity':'textblueBold'}>Rs. {props?.AddonState ? cart?.package_city_prices?.offer_price ? cart?.package_city_prices?.offer_price : cart?.offer_price : cart.is_addon ? cart.addon_price : cart?.package_city_prices?.offer_price ? cart?.package_city_prices?.offer_price : cart?.offer_price }/-</span>
            <span className="btn_neon">Get {discountPercentage}% OFF</span>
          </div>
          {/* {Review ? (
            <div className="price_info">
              <span className="plusMinus">
                <AiOutlineMinusCircle />
                45
                <AiFillPlusCircle />
              </span>
            </div>
          ) : null} */}
        </div>
        :null
        }
        { cart?.price_deference > 0 ?
          <div className="packagePriceChange" style={{borderTop: "1px solid gainsboro"}}>
            <BsFillExclamationCircleFill className="ExclamationCircle" /> <span> Price changed from Rs. {cart?.price_old_city} to Rs. {cart?.price_deference} </span> 
          </div>
          :null
        }
        { cart?.available == false ?
          <div className="packagePriceChange" style={{borderTop: "1px solid gainsboro"}}>
            <BsFillExclamationCircleFill className="ExclamationCircle" /> <span> This Item is not available for this City </span> 
          </div>
          :null
        }
      </div>
    </div>
    <Modal open={open} onClose={onCloseModal} center classNames={{
      modal: 'deletePackageCartM',}}
    >
      {/*<hr className="topHr" />*/}
      <div className="packageTitle">
        <h2>{packageData?.package.name}</h2>
      </div>
      <hr/>
      <div className="packageContent">
        <p>Are you sure you want to remove this item?</p>
      </div>
      <div className="cartButtons">
        <button className="closeModal" onClick={()=>closeModal()}>No</button><button className="deleteModal" onClick={()=>deletePackage(packageData?.id)}>Yes</button>
      </div>
    </Modal>
    {/* <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ fontSize: "1.8rem" }}
      /> */}
    </>
  );
};
const mapStateToProps = (state) => ({
  AddonState: state?.AddonSetter?.Addon

});

const mapDispatchToProps = (dispatch) => {
  return {
    
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(PackageInfo))

